/** Core Shell main column (`ShellLayout.jsx`) — overlays here avoid covering TopNav / SideNav. */
export const SHELL_MAIN_CONTENT_ID = 'shell-main-content';

/**
 * @returns {HTMLElement | null}
 */
export function getShellMainContentEl() {
  if (typeof document === 'undefined') return null;
  return document.getElementById(SHELL_MAIN_CONTENT_ID);
}
